import { QueryParams } from '@ml/shared/types/query-params';

export class TaskQueryParams extends QueryParams {
  status: string;
  employee: number;
}
